export interface CacheStats {
  enabled: boolean;
  hit_rate: number | null;
  size_bytes: number | null;
  size_entries: number | null;
}

export function CacheTtsCard({ data }: { data: CacheStats }) {
  return (
    <div className="vp-card" style={{ padding: 16 }}>
      <h3 style={{ margin: '0 0 8px', fontSize: 'var(--vp-text-md)' }}>Cache TTS</h3>
      {!data.enabled ? (
        <p style={{ margin: 0, color: 'var(--vp-text-2)' }}>Disabilitata (TTS_CACHE_ENABLED=false)</p>
      ) : (
        <ul style={{ margin: 0, paddingLeft: 16 }}>
          <li>hit-rate: {data.hit_rate !== null ? (data.hit_rate * 100).toFixed(1) + '%' : '—'}</li>
          <li>entries: {data.size_entries ?? '—'}</li>
          <li>size: {data.size_bytes !== null ? Math.round(data.size_bytes / 1024) + ' KB' : '—'}</li>
        </ul>
      )}
    </div>
  );
}
